import { CasinoGameInfo, MenuPosition } from "../http/protocol";

import {NavigationActions, NavigationActionTypes, setMenuStateInLocalStorage} from "./NavigationActions";

export interface NavigationState {
    showUserNavigation?: boolean;
    tab: number
    sportsbookVisible:boolean;
    sportsbookLoaded: boolean;
    isSideMenuExpanded? : boolean;
    sideMenuPosition?: MenuPosition;
    isLandingPage? : boolean;
    pokerVisible : boolean;
    pokerLoadingComplete? : boolean;
    previousPaths? : [];
    captchaLoaded?: boolean;
    mobilePreviewGame? : CasinoGameInfo;
}
const initial : NavigationState = { sportsbookLoaded : false, pokerLoadingComplete : false, showUserNavigation : false, tab: 0, sportsbookVisible:false, isSideMenuExpanded : false, isLandingPage : false, pokerVisible: false, previousPaths : []}
export function navigationReducer( state = initial, action : NavigationActions) {

    switch (action.type) {
        case NavigationActionTypes.ADD_PATH:
            let paths = [action.path].concat(state.previousPaths ?? []);
            if(paths.length > 5) {
                paths = paths.slice(0,5);
            }
            return {...state, previousPaths : paths};
        case NavigationActionTypes.SHOW_SIDE_MENU:
            setMenuStateInLocalStorage(action.show, state.sideMenuPosition)
            return {...state, isSideMenuExpanded : action.show};
        case NavigationActionTypes.SHOW_USER_NAVIGATION:
            return {...state, showUserNavigation : action.show};
        case NavigationActionTypes.SET_ACTIVE_TAB:
            return {...state, tab : action.tab};
        case NavigationActionTypes.SHOW_SPORTSBOOK:
            let loaded = state.sportsbookLoaded;
            if(action.show == true) {
                loaded = true;
            }
            return {...state, sportsbookVisible : action.show, sportsbookLoaded : loaded};
        case NavigationActionTypes.IS_LANDING_PAGE:
            return {...state, isLandingPage : action.show};
        case NavigationActionTypes.SHOW_POKER:
            return {...state, pokerVisible : action.show};
        case NavigationActionTypes.POKER_LOADING_COMPLETE:
            return {...state, pokerLoadingComplete : action.complete};
        case NavigationActionTypes.SELECT_MOBILE_PREVIEW:
            return {...state, mobilePreviewGame : action.game};
        case NavigationActionTypes.SET_SIDEMENU_POSITION:
            return {...state, sideMenuPosition : action.position};
        default:
            return state;
    }
}